import React from "react";
import { Cross, SearchIcon } from "../../../icons";

const MyOrgSearch = props => {
  const { textSearch, setTextSearch } = props;
  return (
    <div className="event-page-explore-filter events-page-myorg-search">
      <div className="event-page-explore-filter-col event-page-explore-filter-search">
        <span className="event-page-explore-filter-search-icon">
          <SearchIcon />
        </span>
        <input
          className="event-page-explore-filter-search-input"
          type="search"
          value={textSearch}
          onChange={e => {
            setTextSearch(e.target?.value);
          }}
          placeholder="Search your orgs... "
        />
        {textSearch && (
          <button
            onClick={() => {
              setTextSearch("");
            }}
            className="event-page-explore-filter-search-btn"
            type="button"
          >
            <Cross />
          </button>
        )}
      </div>
    </div>
  );
};

export default MyOrgSearch;
